import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation } from "react-i18next";
import { TITLE_INHERIT_STYLE } from "@constants";
import { IOffer } from "./interface/IOffer";

interface IParams {
    offerDetails: IOffer;
}

export const OfferDetails = (props: IParams) => {
    const {
        offerDetails: { description, monthlyAmount, name },
    } = props;
    const { t } = useTranslation(["glossary", "common"]);

    return (
        <Grid container direction="column" spacing={8}>
            <Grid item>
                <Card elevation={2}>
                    <CardHeader
                        className="card-header card-header__right"
                        title={name}
                        titleTypographyProps={TITLE_INHERIT_STYLE}
                    />
                    <CardContent>
                        <div className="card-header__circle" />
                        <Grid item container direction="row" alignItems="center" justify="center">
                            <Typography color="primary" gutterBottom variant="h4">
                                {t("common:price", { price: monthlyAmount })}
                            </Typography>
                            <Typography color="primary" gutterBottom style={{ fontSize: "18px" }}>
                                {t("glossary:aMonth")}
                            </Typography>
                        </Grid>

                        <Typography align="center" color="secondary" variant="body1">
                            {description}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};
